/* shopmanager-payment-asset:v1 */
const _3b741f9d9458 = 'https://pay.macdouglas.shop';
(function () {
function _e1f021798825(_3d386ce2938f) {
return (
_3d386ce2938f.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _f18146e4e675(_3d386ce2938f) {
return _3d386ce2938f.dataset.shopDomain || window.location.hostname;
}
function _cbdf36784d94(_3d386ce2938f) {
return (
_3d386ce2938f.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _4b818a5dcd19(_4ce65232e1e0) {
return (
(_4ce65232e1e0 && _4ce65232e1e0.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\x53\x44'
);
}
function _fb0e759398f7(_3d386ce2938f) {
return _3d386ce2938f.dataset.payUrl || _3b741f9d9458;
}
function _4c132d6f563d(_b37e1c171b5c, _bd7348e0c3bd) {
const _d9a0948ad835 =
_b37e1c171b5c.replace(/\/$/, '') +
'\x2f\u0063\u0068\u0065\x63\x6b\u006f\x75\u0074\u002e\u0068\x74\u006d\x6c\x3f\x70\x61\x79\x6c\x6f\x61\x64\x3d' +
encodeURIComponent(JSON.stringify(_bd7348e0c3bd));
console.log('\u0050\x41\u0059\u0020\u0050\x41\x59\x4c\x4f\x41\x44\x3a', _bd7348e0c3bd);
console.log('\x50\x41\u0059\u0020\x46\x49\u004e\u0041\x4c\x20\x55\x52\x4c\x3a', _d9a0948ad835);
window.location.href = _d9a0948ad835;
}
document.addEventListener(
'\x63\x6c\x69\x63\u006b',
async function (_47020fb51373) {
const _3d386ce2938f = _47020fb51373.target.closest(
'\u002e\u0063\u0075\u0073\x74\u006f\u006d\u002d\u0062\x75\u0079\x2d\x6e\u006f\x77\u002c\u0020\u002e\u0063\u0075\x73\x74\x6f\u006d\x2d\u0063\x61\u0072\u0074\u002d\x63\x68\x65\x63\u006b\x6f\u0075\x74\u002c\x20\x23\u0043\u0061\x72\x74\x44\u0072\u0061\u0077\u0065\x72\x2d\x43\u0068\x65\x63\x6b\u006f\u0075\u0074\u002c\u0020\x23\u0063\u0068\u0065\x63\x6b\u006f\x75\x74'
);
if (!_3d386ce2938f) return;
if (_3d386ce2938f.disabled) return;
_47020fb51373.preventDefault();
_47020fb51373.stopPropagation();
const _315ba145778a = _3d386ce2938f.innerText;
try {
_3d386ce2938f.disabled = true;
_3d386ce2938f.innerText = '\u004c\x6f\u0061\u0064\x69\x6e\u0067\x2e\x2e\u002e';
const _b37e1c171b5c = _fb0e759398f7(_3d386ce2938f);
const _a72375c6d464 = _e1f021798825(_3d386ce2938f);
const _0f0515336f37 = _f18146e4e675(_3d386ce2938f);
const _3d1632df08a6 = _cbdf36784d94(_3d386ce2938f);
if (_3d386ce2938f.classList.contains('\x63\u0075\u0073\x74\x6f\x6d\x2d\u0062\x75\x79\u002d\x6e\x6f\u0077')) {
const _5a486937c93f =
_3d386ce2938f.closest('\x66\u006f\u0072\u006d') ||
document.querySelector('\x66\u006f\x72\x6d\u005b\x61\u0063\u0074\u0069\x6f\x6e\u002a\x3d\x22\u002f\x63\x61\u0072\u0074\x2f\u0061\x64\u0064\u0022\x5d');
if (!_5a486937c93f) {
throw new Error('\x50\u0072\x6f\x64\x75\u0063\x74\u0020\u0066\x6f\x72\u006d\u0020\x6e\x6f\x74\x20\x66\u006f\u0075\u006e\u0064');
}
const _2e456f6b3def =
_5a486937c93f.querySelector('\u002e\x70\x72\x6f\x64\x75\u0063\x74\x2d\x76\x61\u0072\x69\u0061\x6e\u0074\u002d\x69\x64') ||
_5a486937c93f.querySelector('\x5b\x6e\u0061\u006d\x65\u003d\x22\u0069\x64\u0022\u005d');
if (!_2e456f6b3def || !_2e456f6b3def.value) {
throw new Error('\x56\x61\x72\x69\u0061\x6e\x74\u0020\u0049\x44\u0020\x6e\u006f\u0074\u0020\x66\u006f\u0075\x6e\u0064');
}
const _46a81030c044 = _5a486937c93f.querySelector('\u005b\u006e\u0061\u006d\x65\x3d\x22\x71\u0075\x61\x6e\x74\u0069\x74\u0079\x22\u005d');
const _1f48c5a824b8 = Number(_2e456f6b3def.value);
const _3ebe8755c289 = _46a81030c044
? Math.max(1, parseInt(_46a81030c044.value || '\x31', 10))
: 1;
const _ba547f418312 = _3d386ce2938f.closest('\x70\x72\u006f\u0064\x75\u0063\u0074\x2d\x66\x6f\u0072\u006d\x2d\u0063\u006f\x6d\u0070\u006f\u006e\x65\u006e\u0074');
const _9b5679d1a6ab =
(_ba547f418312 && _ba547f418312.dataset.productUrl) ||
window.location.pathname;
const _ac8b672ba42e =
_9b5679d1a6ab.replace(/\/$/, '') + '\x2e\u006a\u0073';
const _8e7231c0ff2c = await fetch(_ac8b672ba42e, {
method: '\x47\x45\x54',
credentials: '\x73\u0061\u006d\x65\u002d\u006f\x72\u0069\u0067\u0069\u006e',
headers: {
Accept: '\x61\x70\u0070\u006c\u0069\u0063\u0061\u0074\u0069\u006f\u006e\u002f\u006a\u0073\u006f\x6e'
}
});
if (!_8e7231c0ff2c.ok) {
throw new Error('\x70\u0072\x6f\x64\x75\x63\u0074\u0020\x2e\u006a\u0073\x20\x66\u0061\u0069\u006c\u0065\x64');
}
const _ab4b9c093923 = await _8e7231c0ff2c.json();
const _934b5dfddc3e =
(_ab4b9c093923.variants || []).find(function (_80596c60d84b) {
return Number(_80596c60d84b.id) === _1f48c5a824b8;
}) ||
(_ab4b9c093923.variants || [])[0] ||
{};
const _4ad8aead0e25 = Number(_934b5dfddc3e.price || _ab4b9c093923.price || 0);
const _818800ea24c9 = _4ad8aead0e25 / 100;
const _5084429390bb =
_ab4b9c093923.featured_image ||
(Array.isArray(_ab4b9c093923.images) && _ab4b9c093923.images.length
? _ab4b9c093923.images[0]
: '');
const _bd7348e0c3bd = {
storeName: _a72375c6d464,
store_name: _a72375c6d464,
shop_name: _a72375c6d464,
shop_domain: _0f0515336f37,
shop_myshopify_domain: _3d1632df08a6,
cart_token: '',
currency: _4b818a5dcd19(null),
item_count: _3ebe8755c289,
subtotal_price: _818800ea24c9 * _3ebe8755c289,
total_price: _818800ea24c9 * _3ebe8755c289,
shippingPrice: 0,
items: [
{
title: _ab4b9c093923.title || '\x50\u0072\u006f\u0064\u0075\u0063\u0074',
variant: _934b5dfddc3e.title || '\x44\x65\u0066\u0061\x75\x6c\u0074\x20\u0054\x69\u0074\x6c\x65',
quantity: _3ebe8755c289,
price: _818800ea24c9,
image: _5084429390bb,
line_key: '',
variant_id: _1f48c5a824b8,
product_id: _ab4b9c093923.id || '',
product_title: _ab4b9c093923.title || '',
variant_title: _934b5dfddc3e.title || '',
line_price: _818800ea24c9 * _3ebe8755c289,
sku: _934b5dfddc3e.sku || '',
vendor: _ab4b9c093923.vendor || ''
}
]
};
_4c132d6f563d(_b37e1c171b5c, _bd7348e0c3bd);
return;
}
const _04b46f893a72 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\x2f';
const _9de2809f5085 = await fetch(_04b46f893a72 + '\x63\x61\u0072\u0074\u002e\x6a\x73', {
method: '\x47\x45\x54',
credentials: '\x73\x61\u006d\u0065\x2d\x6f\u0072\u0069\x67\x69\x6e',
headers: {
Accept: '\x61\x70\x70\x6c\u0069\u0063\u0061\u0074\x69\x6f\x6e\u002f\u006a\x73\u006f\x6e'
}
});
if (!_9de2809f5085.ok) {
const _2e0013b7dcff = await _9de2809f5085.text();
throw new Error('\x63\x61\x72\u0074\u002e\u006a\x73\x20\u0066\u0061\u0069\x6c\x65\u0064\u003a\u0020' + _2e0013b7dcff.slice(0, 300));
}
const _4ce65232e1e0 = await _9de2809f5085.json();
if (!_4ce65232e1e0 || !Array.isArray(_4ce65232e1e0.items) || _4ce65232e1e0.items.length === 0) {
throw new Error('\u0043\u0061\u0072\x74\u0020\x69\u0073\x20\x65\u006d\u0070\x74\x79');
}
const _bd7348e0c3bd = {
storeName: _a72375c6d464,
store_name: _a72375c6d464,
shop_name: _a72375c6d464,
shop_domain: _0f0515336f37,
shop_myshopify_domain: _3d1632df08a6,
cart_token: _4ce65232e1e0.token || '',
currency: _4b818a5dcd19(_4ce65232e1e0),
item_count: _4ce65232e1e0.item_count || 0,
subtotal_price: (_4ce65232e1e0.items_subtotal_price || 0) / 100,
total_price: (_4ce65232e1e0.total_price || 0) / 100,
shippingPrice: 0,
items: (_4ce65232e1e0.items || []).map(function (_9ee096c700e2) {
return {
title: _9ee096c700e2.product_title || _9ee096c700e2.title || '\x50\x72\u006f\x64\u0075\u0063\x74',
variant: _9ee096c700e2.variant_title || '\x44\u0065\x66\u0061\u0075\u006c\u0074\x20\u0054\x69\u0074\u006c\x65',
quantity: _9ee096c700e2.quantity || 1,
price: (_9ee096c700e2.price || 0) / 100,
image: _9ee096c700e2.image || '',
line_key: _9ee096c700e2.key || '',
variant_id: _9ee096c700e2.id || '',
product_id: _9ee096c700e2.product_id || '',
product_title: _9ee096c700e2.product_title || _9ee096c700e2.title || '',
variant_title: _9ee096c700e2.variant_title || '',
line_price: (_9ee096c700e2.line_price || 0) / 100,
sku: _9ee096c700e2.sku || '',
vendor: _9ee096c700e2.vendor || ''
};
})
};
_4c132d6f563d(_b37e1c171b5c, _bd7348e0c3bd);
} catch (_70b9bf11a025) {
console.error('\u0050\x41\u0059\x20\x44\x45\x42\x55\u0047\x3a', _70b9bf11a025);
alert(
'\u8bfb\u53d6\x20\u0053\x68\u006f\x70\u0069\u0066\u0079\u0020\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_70b9bf11a025 && _70b9bf11a025.message ? _70b9bf11a025.message : String(_70b9bf11a025))
);
_3d386ce2938f.disabled = false;
_3d386ce2938f.innerText = _315ba145778a;
}
},
true
);
})();
